/**
 * Hace un submit si el componente en el que se pone cambia.
 * Se puede indicar requestSubmit en vez de submit, para evitar que se dispare el evento
 * submit del formulario y lance un requestSubmit que es el que usa Turbo
 */
/* global $ */
export default {
  beforeMount(el, bindings, _vnode) {
    if (bindings.value === false) {
      return;
    }

    let input;
    if (bindings.value && bindings.value.selectorElemento) {
      input = el.querySelector(bindings.value.selectorElemento);
    } else {
      input = el;
    }
    input.addEventListener('change', (event) => {
      // Los eventos change que vienen de la carga inicial de un componente
      // (p.ej. SelectorEstructura con valoresIniciales) no deben provocar submit
      if (event.detail?.inicial) return;

      const form = input.closest('form');
      if (bindings.value === 'jquery') {
        // Esto es porque por ejemplo en los boletines hay que lanzar el evento jquery para que el
        // componente que gestiona el listado se entere.
        $(form).submit();
      } else if (bindings.value === 'requestSubmit') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  },
};
